var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#94A3B8",
    d: "m16.478 6.025.012-.013-3.104-3.095-.883.883 1.758 1.758a2.081 2.081 0 1 0 1.575 3.85v6.009a.836.836 0 0 1-.833.833.836.836 0 0 1-.834-.833v-3.75c0-.921-.746-1.667-1.666-1.667h-.834V4.167c0-.921-.746-1.667-1.666-1.667h-5c-.921 0-1.667.746-1.667 1.667V17.5h8.333v-6.25h1.25v4.167a2.084 2.084 0 0 0 4.167 0V7.5c0-.575-.233-1.096-.608-1.475Zm-6.475 2.308h-5V4.167h5v4.166Zm5 0a.836.836 0 0 1-.834-.833c0-.458.375-.833.834-.833.458 0 .833.375.833.833a.836.836 0 0 1-.833.833Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/Gas.706f610518d330323b23b597bbb5eda4.svg";
export { ForwardRef as ReactComponent };